import CustomHead from 'components/commons/CustomHead'
import Template from 'components/contact-completed-lp'
import useLocalStorage from 'hooks/useLocalStorage'

const ContactCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDesignSystemLPContactPage')

  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={
            'i3DESIGN UI/UX デジタルトランスフォーメーション デザイン思考 デザイン経営 デザインパートナー サービスデザイン クラウドネイティブ'
          }
          image={'https://www.i3design.jp/OGP_logo.png'}
          url={'https://www.i3design.jp/lp-designsystem-contact-completed/'}
          title="お問い合わせありがとうございました | i3DESIGN アイスリーデザイン"
          description=""
          noindexNofollow={true}
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default ContactCompleted
